'use client'

import React from 'react'
import HoverMenu from '@/components/NavBar/HoverMenu'
import BrowseDropdownContent from '@/components/NavBar/BrowseDropdownContent'
import { useIsMobile } from '@/lib/mobileDetector'
import { useBreakpoint } from '@/hooks/useBreakpoints'
import { useUserContext } from '@/contexts/UserContext'
import { StoreAnalytics, trackStoreEvent } from '@nile/mantine-theme/analytics'

const trackEvent = (name: string) => trackStoreEvent(StoreAnalytics.NAV_HEADER_CLICKED, { name })

export function BrowseButton() {
    const isMobile = useIsMobile()
    const { isSm, isMd, isLg, isXl } = useBreakpoint()
    const { user } = useUserContext()
    if (isSm) return null

    const showHoverDropdown = !isMobile && (isMd || isLg || isXl)

    return (
        <HoverMenu
            buttonTitle="Browse all"
            onButtonClick={() => trackEvent('browse')}
            disabled={!showHoverDropdown}
            dataTestId="browse-button"
        >
            <BrowseDropdownContent
                loggedIn={!!user}
                onClose={() => {}}
                onItemClick={(slug: string) => trackEvent(`browse-${slug}`)}
            />
        </HoverMenu>
    )
}
